import { PRODUCTION, DEVELOPMENT, LOCAL_COMPLIANCE_URL } from "./const";
import { isEmpty } from "lodash";

export function getTradeComplianceUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const API_URL = !!process.env.REACT_APP_COMPLIANCE_URL && process.env.REACT_APP_COMPLIANCE_URL !== "" ? process.env.REACT_APP_COMPLIANCE_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_COMPLIANCE_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return LOCAL_COMPLIANCE_URL;
    }
  } else {
    return LOCAL_COMPLIANCE_URL;
  }
}

export const getTradeComplianceUrlValue = (path) => {
  return `${getTradeComplianceUrl()}/${path}`;
};
